/**
 * Maps frontend sport name to backend API sport name
 * @param {String} sport - Frontend sport name
 * @return {String} Backend API sport name
 */
export function getApiSport(sport) {
  return sport === 'nrl' ? 'rugby-league' : sport
}



// WEBPACK FOOTER //
// ../app/lib/utils/getApiSport.js